import "./src/styles/global.css"
document.body.style.zoom = "87%"
